// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --color-grey-225-10-15: hsl(225, 10%, 15%); /* text */
  --color-grey-225-10-35: hsl(225, 10%, 35%); /* icons */
  --color-grey-225-10-55: hsl(225, 10%, 55%);
  --color-grey-225-10-75: hsl(225, 10%, 75%); /* lines */
  --color-grey-225-10-80: hsl(225, 10%, 80%); /* hover on grey bg */
  --color-grey-225-10-85: hsl(225, 10%, 85%); /* app window */
  --color-grey-225-10-90: hsl(225, 10%, 90%); /* button hover */
  --color-grey-225-10-95: hsl(225, 10%, 95%); /* backgrounds, hover */
  --color-grey-225-10-97: hsl(225, 10%, 97%); /* form element backgrounds */

  --color-blue-205-100-45: hsl(205, 100%, 45%); /* primary hover */
  --color-blue-205-100-50: hsl(205, 100%, 50%); /* primary */
  --color-blue-205-100-95: hsl(205, 100%, 95%);

  --color-green-150-86-44: hsl(150, 86%, 44%); /* success */

  --color-red-360-100-40: hsl(360, 100%, 40%); /* warning hover */
  --color-red-360-100-45: hsl(360, 100%, 45%); /* warning */
  --color-red-360-100-92: hsl(360, 100%, 92%); /* hover */
  --color-red-360-100-97: hsl(360, 100%, 97%); /* backgrounds */

  --color-orange-20-98-52: hsl(20, 98%, 52%); /* new badges */

  --color-white: hsl(0, 0%, 100%);
  --color-white-opacity-80: hsla(0, 0%, 100%, 80%);
  --color-black: hsl(0, 0%, 0%); 
  --color-black-opacity-10: hsla(0, 0%, 0%, 10%); 
  --color-black-opacity-30: hsla(0, 0%, 0%, 30%);
}

:root {
  --font-family: 'IBM Plex Sans', system-ui, Arial, sans-serif;
  --font-family-monospace: 'IBM Plex Mono', monospace;
  --font-size-default: 14px;
}

* {
  box-sizing: border-box;
}

html, body, .root {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;

  font-family: var(--font-family);
  font-size: var(--font-size-default);
}

.root {
  display: flex;
  flex-direction: column;
}

.playground {
  height: 80%;
  flex-grow: 1;
  display: flex;
  flex-direction: row;
}

.bio-properties-panel {
  --font-family: var(--font-family);
}

.status-bar {
  display: flex;
  flex-flow: row;
  align-items: stretch;
  flex: none;
  z-index: 1000;
  height: 32px;
  padding: 0;
  background-color: var(--color-grey-225-10-85);
  border-top: 1px solid var(--color-grey-225-10-75);
  color: var(--color-grey-225-10-15);
  font-size: 14px;
  line-height: 28px;
}

.status-bar .execution-platform,
.status-bar .branch-name {
  margin-top: 2px;
}

.status-bar .buttons {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.status-bar .buttons + .buttons {
  margin: 0 auto;
}

.status-bar .buttons + .buttons + .buttons {
  margin: 0;
}

.status-bar .buttons > * {
  padding: 0 10px;
  user-select: none;
  height: 100%;
}

.status-bar button {
  align-items: center;
  border: 0;
  border-radius: 0;
  color: inherit;
  background-color: inherit;
  font-weight: normal;
  font-size: inherit;
  font-family: inherit;
  justify-content: center;
  display: flex;
  flex-flow: row;
}

.status-bar button.has-errors {
  color: var(--color-red-360-100-45);
}

.status-bar button svg {
  fill: currentColor;
  margin-right: 2px;
  margin-left: -5px;
  width: 24px;
  height: 24px;
}

.status-bar button img {
  margin-right: 6px;
  width: 16px;
  height: 16px;
}

.status-bar button.has-errors svg {
  fill: var(--color-red-360-100-45);
}

.status-bar button.design svg,
.status-bar button.validate svg {
  transform: scale(0.7);
}

.status-bar button:hover {
  background-color: var(--color-grey-225-10-80);
}

.status-bar button.active {
  background-color: var(--color-grey-225-10-75);
}

.status-bar button.active:hover {
  background-color: var(--color-grey-225-10-75);
}`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;EACE,0CAA0C,EAAE,SAAS;EACrD,0CAA0C,EAAE,UAAU;EACtD,0CAA0C;EAC1C,0CAA0C,EAAE,UAAU;EACtD,0CAA0C,EAAE,qBAAqB;EACjE,0CAA0C,EAAE,eAAe;EAC3D,0CAA0C,EAAE,iBAAiB;EAC7D,0CAA0C,EAAE,uBAAuB;EACnE,0CAA0C,EAAE,6BAA6B;;EAEzE,4CAA4C,EAAE,kBAAkB;EAChE,4CAA4C,EAAE,YAAY;EAC1D,4CAA4C;;EAE5C,2CAA2C,EAAE,YAAY;;EAEzD,2CAA2C,EAAE,kBAAkB;EAC/D,2CAA2C,EAAE,YAAY;EACzD,2CAA2C,EAAE,UAAU;EACvD,2CAA2C,EAAE,gBAAgB;;EAE7D,0CAA0C,EAAE,eAAe;;EAE3D,+BAA+B;EAC/B,gDAAgD;EAChD,6BAA6B;EAC7B,8CAA8C;EAC9C,8CAA8C;AAChD;;AAEA;EACE,4DAA4D;EAC5D,mDAAmD;EACnD,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,gBAAgB;;EAEhB,+BAA+B;EAC/B,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,UAAU;EACV,aAAa;EACb,YAAY;EACZ,UAAU;EACV,6CAA6C;EAC7C,iDAAiD;EACjD,kCAAkC;EAClC,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,uBAAuB;EACvB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;AAC/C","sourcesContent":[":root {\n  --color-grey-225-10-15: hsl(225, 10%, 15%); /* text */\n  --color-grey-225-10-35: hsl(225, 10%, 35%); /* icons */\n  --color-grey-225-10-55: hsl(225, 10%, 55%);\n  --color-grey-225-10-75: hsl(225, 10%, 75%); /* lines */\n  --color-grey-225-10-80: hsl(225, 10%, 80%); /* hover on grey bg */\n  --color-grey-225-10-85: hsl(225, 10%, 85%); /* app window */\n  --color-grey-225-10-90: hsl(225, 10%, 90%); /* button hover */\n  --color-grey-225-10-95: hsl(225, 10%, 95%); /* backgrounds, hover */\n  --color-grey-225-10-97: hsl(225, 10%, 97%); /* form element backgrounds */\n\n  --color-blue-205-100-45: hsl(205, 100%, 45%); /* primary hover */\n  --color-blue-205-100-50: hsl(205, 100%, 50%); /* primary */\n  --color-blue-205-100-95: hsl(205, 100%, 95%);\n\n  --color-green-150-86-44: hsl(150, 86%, 44%); /* success */\n\n  --color-red-360-100-40: hsl(360, 100%, 40%); /* warning hover */\n  --color-red-360-100-45: hsl(360, 100%, 45%); /* warning */\n  --color-red-360-100-92: hsl(360, 100%, 92%); /* hover */\n  --color-red-360-100-97: hsl(360, 100%, 97%); /* backgrounds */\n\n  --color-orange-20-98-52: hsl(20, 98%, 52%); /* new badges */\n\n  --color-white: hsl(0, 0%, 100%);\n  --color-white-opacity-80: hsla(0, 0%, 100%, 80%);\n  --color-black: hsl(0, 0%, 0%); \n  --color-black-opacity-10: hsla(0, 0%, 0%, 10%); \n  --color-black-opacity-30: hsla(0, 0%, 0%, 30%);\n}\n\n:root {\n  --font-family: 'IBM Plex Sans', system-ui, Arial, sans-serif;\n  --font-family-monospace: 'IBM Plex Mono', monospace;\n  --font-size-default: 14px;\n}\n\n* {\n  box-sizing: border-box;\n}\n\nhtml, body, .root {\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n\n  font-family: var(--font-family);\n  font-size: var(--font-size-default);\n}\n\n.root {\n  display: flex;\n  flex-direction: column;\n}\n\n.playground {\n  height: 80%;\n  flex-grow: 1;\n  display: flex;\n  flex-direction: row;\n}\n\n.bio-properties-panel {\n  --font-family: var(--font-family);\n}\n\n.status-bar {\n  display: flex;\n  flex-flow: row;\n  align-items: stretch;\n  flex: none;\n  z-index: 1000;\n  height: 32px;\n  padding: 0;\n  background-color: var(--color-grey-225-10-85);\n  border-top: 1px solid var(--color-grey-225-10-75);\n  color: var(--color-grey-225-10-15);\n  font-size: 14px;\n  line-height: 28px;\n}\n\n.status-bar .execution-platform,\n.status-bar .branch-name {\n  margin-top: 2px;\n}\n\n.status-bar .buttons {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n}\n\n.status-bar .buttons + .buttons {\n  margin: 0 auto;\n}\n\n.status-bar .buttons + .buttons + .buttons {\n  margin: 0;\n}\n\n.status-bar .buttons > * {\n  padding: 0 10px;\n  user-select: none;\n  height: 100%;\n}\n\n.status-bar button {\n  align-items: center;\n  border: 0;\n  border-radius: 0;\n  color: inherit;\n  background-color: inherit;\n  font-weight: normal;\n  font-size: inherit;\n  font-family: inherit;\n  justify-content: center;\n  display: flex;\n  flex-flow: row;\n}\n\n.status-bar button.has-errors {\n  color: var(--color-red-360-100-45);\n}\n\n.status-bar button svg {\n  fill: currentColor;\n  margin-right: 2px;\n  margin-left: -5px;\n  width: 24px;\n  height: 24px;\n}\n\n.status-bar button img {\n  margin-right: 6px;\n  width: 16px;\n  height: 16px;\n}\n\n.status-bar button.has-errors svg {\n  fill: var(--color-red-360-100-45);\n}\n\n.status-bar button.design svg,\n.status-bar button.validate svg {\n  transform: scale(0.7);\n}\n\n.status-bar button:hover {\n  background-color: var(--color-grey-225-10-80);\n}\n\n.status-bar button.active {\n  background-color: var(--color-grey-225-10-75);\n}\n\n.status-bar button.active:hover {\n  background-color: var(--color-grey-225-10-75);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
